import { ProblemaCondicaoSelectFieldModel } from 'components/form/field/select/ProblemaCondicaoSelectField/ProblemaCondicaoSelectField'
import createDecorator from 'final-form-calculate'
import { metaPath } from 'util/metaPath'

import { convertProblemaCondicao } from './converter'
import { ProblemaCondicaoModel } from './model'

const meta = metaPath<ProblemaCondicaoModel>()

export const createProblemaCondicoesCalculator = (dataNascimentoCidadao: LocalDate) =>
  createDecorator({
    field: [meta.problemaCondicaoEvoluir.absolutePath()],
    updates: (value: ProblemaCondicaoSelectFieldModel) => convertProblemaCondicao(value, dataNascimentoCidadao),
  })
